// utils/auth-cookie-manager.js
// Cookie management utilities for authentication

const COOKIE_NAME = 'auth_session';
const COOKIE_EXPIRY_DAYS = 7;

export const saveAuthToCookies = (user) => {
  if (!user) return;
  
  const authData = {
    uid: user.uid,
    email: user.email,
    displayName: user.displayName,
    photoURL: user.photoURL,
    timestamp: new Date().toISOString()
  };
  
  const expires = new Date();
  expires.setDate(expires.getDate() + COOKIE_EXPIRY_DAYS);
  
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(JSON.stringify(authData))}; expires=${expires.toUTCString()}; path=/; SameSite=Strict; Secure`;
};

export const getAuthFromCookies = () => {
  const cookies = document.cookie.split(';');
  
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === COOKIE_NAME && value) {
      try {
        return JSON.parse(decodeURIComponent(value));
      } catch (e) {
        console.error('Error parsing auth cookie:', e);
        return null;
      }
    }
  }
  
  return null;
};

export const clearAuthCookies = () => {
  document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict; Secure`;
};

export const isAuthenticated = () => {
  const authData = getAuthFromCookies();
  return authData !== null;
};

export const checkCookieIntegrity = () => {
  const authData = getAuthFromCookies();
  if (!authData) return false;
  
  // Check if cookie data has required fields
  return !!(authData.uid && authData.email);
};